import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { Vehicle } from '@/types/vehicle';

export const getVehicles = async (loginUserEmail?: string): Promise<ApiResult<Vehicle[]>> => {
  const { status, result } = await callApi<Vehicle[]>(
    `vehicles`,
    'GET',
    undefined,
    undefined,
    loginUserEmail,
    undefined,
    true
  );
  return { status, result };
};
